<script>
  import TextField from 'smelte/src/components/TextField/TextField.svelte'
  import Button from 'smelte/src/components/Button/Button.svelte'
  import { onMount } from 'svelte'
  import { getURL } from '../utils'
  import axios from 'axios'
  import { userStore, is } from '../store'
  import Icon from 'fa-svelte'
  import { faChevronRight, faChevronDown, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
  import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'
  import { push } from 'svelte-spa-router'
  import { writable } from 'svelte/store'
  import { slide } from 'svelte/transition'
  import Uploader from '../components/Uploader.svelte'
  import { conditionMonitoringAPI } from '../components/ConditionMonitoring/api'
  import { API } from '../api/api'

  let cmAPI = new conditionMonitoringAPI()
  let api = new API()

  let defSettings = {
    'roles': {
      roles: {}
    },
    'conveyor-chains': {
      chains: {}
    },
    'machine-status': {
      value: []
    }
  }

  let sectionsState = writable({user_roles: false, chain_types: false, machine_status: false, load_pictures: false})

  $: settings = defSettings

  const docs = [
    {key: 'roles', prop: 'roles'},
    {key: 'conveyor-chains', prop: 'chains'},
    {key: 'machine-status', prop: 'value'},
  ]

  let savedImages = []

  let helpLinks = {
    a: 'https://software.support.flexlink.io/support/solutions/articles/35000177690-admin-settings-parameters-conveyor-condition-monitoring-tool',
    userRoles: 'https://software.support.flexlink.io/support/solutions/articles/35000177695-admin-settings-new-my-flexlink-user-roles',
    machineStatus: 'https://software.support.flexlink.io/support/solutions/articles/35000177697-admin-settings-new-my-flexlink-machine-status',
    chainTypes: 'https://software.support.flexlink.io/support/solutions/articles/35000177698-admin-settings-new-my-flexlink-chain-types',
    loadPictures: 'https://software.support.flexlink.io/support/solutions/articles/35000177700-admin-settings-new-my-flexlink-load-pictures',
  }

  onMount(async () => {
    // load settings
    for (let doc of docs) {
      let url = getURL('/ib/api/v1/settings/' + doc.key)
      await axios.get(url, {withCredentials: true})
        .then(res => {
          if (res.data != null) {
            defSettings[doc.key][doc.prop] = res.data[doc.prop]
          }
        })
    }
    // console.log('[DEBUG] def settings 1', defSettings)

    let props = [
      defSettings.roles.roles,
      defSettings['conveyor-chains'].chains,
      defSettings['machine-status'],
    ]
    props.forEach(prop => {
      Object.keys(prop).forEach(key => {
        prop[key] = JSON.stringify(prop[key])
      })
    })
    defSettings = JSON.parse(JSON.stringify(defSettings))
    // console.log('[DEBUG] def settings 2', defSettings)

    loadFilesList()
  })

  async function loadFilesList () {
    savedImages = await cmAPI.getInstructions()
    if (!savedImages.data || !Array.isArray(savedImages.data)) {
      return
    }
    const root = '/static/uploaded/'
    for (let i = 0; i < savedImages.data.length; i++) {
      savedImages.data[i] = savedImages.data[i].replace(root, '')
    }
  }

  async function saveHandler () {
    const tmp = JSON.parse(JSON.stringify(settings))
    let props = [tmp.roles.roles, tmp['conveyor-chains'].chains]
    props.forEach(prop => {
      Object.keys(prop).forEach(key => {
        prop[key] = JSON.parse(prop[key])
      })
    })
    tmp['machine-status'].value = JSON.parse(tmp['machine-status'].value)

    for (let doc of docs) {
      let url = getURL('/ib/api/v1/settings/' + doc.key)
      axios.post(url, {key: doc.key, ...tmp[doc.key]}, {withCredentials: true})
        .then(res => console.log('[DEBUG] saved', res))
        .catch(err => console.log('[ERROR]', err.message))
    }
    console.log('[DEBUG] save settings', tmp)
  }

  async function fileDeleteHandler (file) {
    console.log('[DEBUG] deleting:', file)
    // savedImages.data = savedImages.data.filter(p => p !== file)

    const i = file.lastIndexOf('/')

    console.log('[DEBUG] i =', i)

    const folder = i < 0 ? '' : file.slice(0, i)

    console.log('[DEBUG] folder =', folder)

    const filename = i < 0 ? file : file.slice(i + 1)

    console.log('[DEBUG] filename =', filename)

    await api.DeleteImage(folder, filename)
    loadFilesList()
  }

</script>

<div class="container mx-auto py-1 px-8 pb-10 bg-white text-left" style="min-height: 700px;">

  {#if is($userStore.roles, 'ib_admin', 'admin')}

    <div class="flex header bg-white my-12">
      <div class="text-xl text-black text-left flex-grow">SETTINGS</div>
      <div class="flex-shrink">
        <Button color="red" remove="rounded" on:click={saveHandler}>save</Button>
      </div>
    </div>

    <div class="overflow-x-auto text-gray-800 mb-6">
      <div class="flex items-center h-16 px-5 mb-3 bg-gray-200"
           on:click={() => $sectionsState.user_roles = !$sectionsState.user_roles}>

        <div class="flex-grow text-lg">
          User local roles
          <span class="text-xl text-gray-600 ml-3" on:click|stopPropagation>
            <a href={helpLinks.userRoles} target="_blank">
              <Icon icon={faQuestionCircle} />
            </a>
          </span>
        </div>
        <div class="text-xl text-gray-500">
          <Icon icon={$sectionsState.user_roles ? faChevronDown : faChevronRight} />
        </div>

      </div>
      {#if $sectionsState.user_roles}
        <div in:slide>
          {#each Object.keys(settings.roles.roles) as key}
            <div class="flex">
              <div class="mr-4">
                <TextField add="font-mono" label="role" value={key} outlined />
              </div>
              <div class="flex-grow">
                <TextField add="font-mono" label="users" outlined
                           bind:value={settings.roles.roles[key]} />
              </div>
            </div>
          {/each}
        </div>
      {/if}
    </div>

    <div class="overflow-x-auto text-gray-800 mb-6">
      <div class="flex items-center h-16 px-5 mb-3 bg-gray-200"
           on:click={() => $sectionsState.machine_status = !$sectionsState.machine_status}>

        <div class="flex-grow text-lg">
          Machine status
          <span class="text-xl text-gray-600 ml-3" on:click|stopPropagation>
            <a href={helpLinks.machineStatus} target="_blank">
              <Icon icon={faQuestionCircle} />
            </a>
          </span>
        </div>
        <div class="text-xl text-gray-500">
          <Icon icon={$sectionsState.machine_status ? faChevronDown : faChevronRight} />
        </div>

      </div>
      {#if $sectionsState.machine_status}
        <div in:slide>
          <div class="flex">
            <div class="flex-grow">
              <TextField add="font-mono" label="machine status" outlined
                         bind:value={settings['machine-status'].value} />
            </div>
          </div>
        </div>
      {/if}
    </div>

    <div class="overflow-x-auto text-gray-800 mb-6">
      <div class="flex items-center h-16 px-5 mb-3 bg-gray-200"
           on:click={() => $sectionsState.chain_types = !$sectionsState.chain_types}>

        <div class="flex-grow text-lg">
          Chain types
          <span class="text-xl text-gray-600 ml-3" on:click|stopPropagation>
            <a href={helpLinks.chainTypes} target="_blank">
              <Icon icon={faQuestionCircle} />
            </a>
          </span>
        </div>
        <div class="text-xl text-gray-500">
          <Icon icon={$sectionsState.chain_types ? faChevronDown : faChevronRight} />
        </div>
      </div>

      {#if $sectionsState.chain_types}
        <div in:slide>

          {#each Object.keys(settings['conveyor-chains'].chains) as key}
            <div class="flex">
              <div class="mr-4">
                <TextField outlined noUnderline add="font-mono" label="platform" value={key} />
              </div>
              <div class="flex-grow">
                <TextField outlined noUnderline add="font-mono" label="chains"
                           bind:value={settings['conveyor-chains'].chains[key]} />
              </div>
            </div>
          {/each}
        </div>
      {/if}

    </div>

    <div class="overflow-x-auto text-gray-800 mb-6">
      <div class="flex items-center h-16 px-5 mb-3 bg-gray-200"
           on:click={() => $sectionsState.load_pictures = !$sectionsState.load_pictures}>

        <div class="flex-grow text-lg">
          Load pictures
          <span class="text-xl text-gray-600 ml-3" on:click|stopPropagation>
            <a href={helpLinks.loadPictures} target="_blank">
              <Icon icon={faQuestionCircle} />
            </a>
          </span>
        </div>
        <div class="text-xl text-gray-500">
          <Icon icon={$sectionsState.load_pictures ? faChevronDown : faChevronRight} />
        </div>
      </div>


      {#if $sectionsState.load_pictures}
        <div in:slide>
          <Uploader on:success={() => {loadFilesList()}} />
        </div>

        <div class="text-gray-700">
          {#await savedImages then res}
            {#each res.data as file}
              <div class="px-4 py-2 flex items-center file-info">
                <div class="flex-grow">
                  {file}
                </div>
                <div class="cursor-pointer text-red-400" on:click={() => { fileDeleteHandler(file) }}>
                  <Icon icon={faTrashAlt} />
                </div>
              </div>
            {/each}
          {/await}
        </div>

      {/if}
    </div>
  {/if}
</div>

<style>
    .file-info:hover {
        background-color: #fff3f5;
    }
</style>